/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_SupportInputs */

const en_mk_foot_support = /** @type {(inputs: Mk_Foot_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const id_mk_foot_support = /** @type {(inputs: Mk_Foot_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bantuan`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Mk_Foot_SupportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_support = /** @type {((inputs?: Mk_Foot_SupportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_SupportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_support(inputs)
	return en_mk_foot_support(inputs)
});